// extracted by mini-css-extract-plugin
export default {"button":"FTg2cblhHemTPqmJTJy0","buttonWrapper":"XgU7x4nMD7DeYsU5bJ1n","container":"Qq6MiCRcMGtet2XGEAXh","tooltip":"MWDttb2GIVhhWFoByAdQ"};